import { Link } from "react-router-dom";
import { Phone, Mail, Facebook } from "lucide-react";
import { BUSINESS, AREAS } from "@/data/site";

export default function Footer() {
  return (
    <footer className="bg-sky-950 pb-24 md:pb-0">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid gap-10 md:grid-cols-3">
          <div>
            <div className="inline-flex rounded-2xl bg-white px-4 py-2.5 shadow-lg shadow-black/20">
              <img src="/logo.png" alt="Julisa's House Cleaning" className="h-16 w-auto" width="600" height="358" />
            </div>
            <p className="mt-2 text-[11px] font-bold uppercase tracking-[0.18em] text-sky-400">Kansas City Metro</p>
            <p className="mt-4 max-w-sm text-sm text-sky-100/70 leading-relaxed">
              Professional cleaning services for homes and businesses — responsible, punctual, and detailed on every visit.
            </p>
            <div className="mt-5 flex flex-col gap-2 text-sm">
              <a href={BUSINESS.phoneHref} data-testid="footer-phone-link" className="flex items-center gap-2 font-semibold text-sky-100 hover:text-white transition-colors">
                <Phone className="h-4 w-4 text-sky-400" aria-hidden="true" /> {BUSINESS.phone}
              </a>
              <a href={BUSINESS.emailHref} data-testid="footer-email-link" className="flex items-center gap-2 font-semibold text-sky-100 hover:text-white transition-colors break-all">
                <Mail className="h-4 w-4 shrink-0 text-sky-400" aria-hidden="true" /> {BUSINESS.email}
              </a>
              <a href={BUSINESS.facebook} target="_blank" rel="noopener noreferrer" data-testid="footer-facebook-link" className="flex items-center gap-2 font-semibold text-sky-100 hover:text-white transition-colors">
                <Facebook className="h-4 w-4 text-sky-400" aria-hidden="true" /> Follow us on Facebook
              </a>
            </div>
          </div>

          <nav aria-label="Footer navigation">
            <h3 className="text-xs font-bold uppercase tracking-[0.2em] text-sky-400">Explore</h3>
            <ul className="mt-4 grid grid-cols-2 gap-2 text-sm">
              {[
                { to: "/", label: "Home" },
                { to: "/services", label: "Services" },
                { to: "/our-work", label: "Our Work" },
                { to: "/about", label: "About" },
                { to: "/service-areas", label: "Service Areas" },
                { to: "/quote", label: "Get a Quote" },
                { to: "/contact", label: "Contact" },
              ].map((l) => (
                <li key={l.to}>
                  <Link to={l.to} data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`} className="text-sky-100/80 hover:text-white transition-colors font-medium">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <h3 className="text-xs font-bold uppercase tracking-[0.2em] text-sky-400">Service Areas</h3>
            <ul className="mt-4 space-y-2 text-sm">
              {AREAS.map((a) => (
                <li key={a.slug}>
                  <Link to="/service-areas" data-testid={`footer-area-${a.slug}`} className="text-sky-100/80 hover:text-white transition-colors font-medium">
                    Cleaning Services in {a.city}, {a.state}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col sm:flex-row items-center justify-between gap-3 border-t border-white/10 pt-6 text-xs text-sky-300/70">
          <p>© {new Date().getFullYear()} {BUSINESS.name}. All rights reserved.</p>
          <p>Serving Overland Park, KS • Lenexa, KS • Olathe, KS • Kansas City, KS • Kansas City, MO</p>
        </div>
      </div>
    </footer>
  );
}
